import { render, staticRenderFns } from "./SINGLECHOICE.vue?vue&type=template&id=b5bd5a66&scoped=true&lang=pug"
import script from "./SINGLECHOICE.vue?vue&type=script&lang=js"
export * from "./SINGLECHOICE.vue?vue&type=script&lang=js"
import style0 from "./SINGLECHOICE.vue?vue&type=style&index=0&id=b5bd5a66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd5a66",
  null
  
)

export default component.exports